import { render } from "./MakeUpOrderDetail.vue?vue&type=template&id=1b59c9b6&scoped=true"
import script from "./MakeUpOrderDetail.vue?vue&type=script&lang=js"
export * from "./MakeUpOrderDetail.vue?vue&type=script&lang=js"

import "./MakeUpOrderDetail.vue?vue&type=style&index=0&id=1b59c9b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b59c9b6"],['__file',"src/views/h5/common/stock/makeUp/MakeUpOrderDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b59c9b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b59c9b6', __exports__)) {
    api.reload('1b59c9b6', __exports__)
  }
  
  module.hot.accept("./MakeUpOrderDetail.vue?vue&type=template&id=1b59c9b6&scoped=true", () => {
    api.rerender('1b59c9b6', render)
  })

}


export default __exports__